module.exports = __webpack_public_path__ + "static/media/HoloConnect_3.7aba4b6b.png";